var map = {
	"./ecart-pay.svg": "31a4",
	"./envia.svg": "b16b",
	"./fulfillment.svg": "7275",
	"./partners.svg": "9398",
	"./returns.svg": "22fb",
	"./wms.svg": "bb66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9493";